import React from 'react';
import { EfMessageGlobal } from '../ef-message';
import './index.scss';
import TimeLimited from './TimeLimited';

export interface EfCheckInActivitiesItemProps {
    /**
     * 当前月数
     */
    month: string;
    /**
     * 当前星期
     */
    week: string;
    /**
     * 当前日
     */
    day: string;
    /**
     * 是否是今天
     */
    today: 'today' | 'before' | 'after';
    /**
     * 可获得多少积分
     */
    score: number;
    /**
     * 已签到类型
     *
     * 1 正常签到
     *
     * 2 补签签到
     *
     * 没有值的是还没有打过卡的
     */
    signInType: 1 | 2;
    /**
     * 允许补卡
     */
    reissueSign?: boolean;
    /**
     * 是否限制打卡
     */
    isLimit?: boolean;
    /**
     * 年月日字符串 2024-11-20
     */
    dateString?: string;
    /**
     * 样式名
     */
    className?: string;
}
interface EfCheckInActivitiesProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 活动URL
     */
    pageUrl?: string;
    /**
     * 自定义时间
     */
    systemTime?: number | null;
    /**
     * 获取打卡信息时回调
     */
    getMsgCallback?: (data: any) => void;
    /**
     * 签到成功回调
     */
    successCallback?: () => void;
    /**
     * 返空回调
     */
    callback?: () => void;
    /**
     * 支持配置化
     */
    data: any;
}

/**
 * 维护:谢保林
 *
 * 打卡活动
 *
 * @description 接口不能额外加时间转换的参数, 后端接口返回的都是对应时区的当地时间 compaignStartTime, compaignEndTime, localCurrentTime
 */
const EfCheckInActivities: React.FC<EfCheckInActivitiesProps> = ({ pageUrl, className, getMsgCallback, successCallback, callback, data }) => {
    return (
        <>
            <TimeLimited getMsgCallback={getMsgCallback} successCallback={successCallback} callback={callback} pageUrl={pageUrl} data={data} />
            <EfMessageGlobal />
        </>
    );
};

export default EfCheckInActivities;
